import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/auth/authentication.service';
import { ApiService } from '../../services/api/api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  credentials: any;
  isLoading = false;
  showPass = false;
  loginError = '';
  year = new Date().getFullYear();

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private apiService: ApiService,
  ) { }

  ngOnInit(): void {
    this.sessionCek();
    this.credentials = new FormGroup({
      username: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required]),
    });
  }

  async sessionCek(){
    let cek = await this.authService.sessionCek();
    if(cek){
      const landing = this.authService.landingRoute();
      if(!landing){ return; } // no usable role — stay on /login, let them re-auth
      await this.router.navigateByUrl(landing, { replaceUrl: true }).then(() => {
        window.location.reload();
      });
    }
  }

  // ===== light / dark theme =====
  isDark() {
    return document.body.classList.contains('theme-dark');
  }

  toggleTheme() {
    const dark = document.body.classList.toggle('theme-dark');
    localStorage.setItem('hatam-theme', dark ? 'dark' : 'light');
  }

  // show inline errors once a field is touched / after a submit attempt
  isInvalid(control: string){
    const c = this.credentials.get(control);
    return c && c.invalid && (c.touched || c.dirty);
  }

  async login() {
    if (this.credentials.invalid) {
      this.credentials.markAllAsTouched();
      return;
    }
    if (this.isLoading) { return; }
    this.isLoading = true;
    this.loginError = '';
    this.authService.login(this.credentials.value).subscribe(
      async (res) => {
        this.isLoading = false;
        if (res && res.status == 200) {
          await this.authService.loadSession();
          const landing = this.authService.landingRoute();
          if(!landing){
            this.authService.logout();
            this.loginError = 'Akun ini belum memiliki akses menu apa pun. Hubungi Super Admin.';
            return;
          }
          await this.router.navigateByUrl(landing, { replaceUrl: true }).then(() => {
            window.location.reload();
          });
        } else {
          // failure lands inline, right where the user is looking
          this.loginError = (res && res.message) || 'Username atau password salah.';
        }
      },
      async () => {
        this.isLoading = false;
        this.loginError = 'Tidak bisa terhubung ke server. Periksa koneksi lalu coba lagi.';
      }
    );
  }
}
